import "./App.css";
import AIButton from "./components/AIButton";
import SetAPIKey from './components/SetAPIKey';
import { useState, useRef, useEffect } from "react";
import { Button, Input, Label } from 'reactstrap';

/*
  Todoアプリのメインコンポーネント
  - Todoリストを表示するコンポーネント
  - Todo追加フォームのコンポーネント
*/
function App() {

  // Todoリストの初期値
  const [todos, setTodos] = useState([
    { id: 0, text: "要件定義", isCompleted: false },
    { id: 1, text: "基本設計", isCompleted: false },
    { id: 2, text: "詳細設計", isCompleted: false },
    { id: 3, text: "実装", isCompleted: false },
    { id: 4, text: "テスト", isCompleted: false }
  ]);

  const [apiKey, setApiKey] = useState('');

  // localStorageからのデータ取得
  useEffect(() => {
    const todos = localStorage.getItem("todos");
    if (todos) {
      setTodos(JSON.parse(todos));
    }
    // localStorageからAPI Keyも取得
    const storedApiKey = localStorage.getItem("apiKey");
    if (storedApiKey) {
      setApiKey(storedApiKey);
    }
  }, []);

  // localStorageにデータを保存する関数
  const updateTodos = (newTodos) => {
    setTodos(newTodos);
    // localStorageに保存
    localStorage.setItem("todos", JSON.stringify(newTodos));
  };

  // Todo削除ボタンのクリックイベント
  const handleTodoDeleteClick = (id) => {
    // Todoリストから削除
    const newTodos = todos.filter((todo) => todo.id !== id);
    updateTodos(newTodos);
  };

  // チェックボックスの状態変化検知イベント
  const handleCheckboxChange = (id, isChecked) => {
    // チェックボックスの状態を変更
    const newTodos = [...todos];
    newTodos.find((todo) => todo.id === id).isCompleted = isChecked;
    updateTodos(newTodos);
  };

  // Todo編集ボタンのクリックイベント
  const handleTodoEditClick = (id, text) => {
    // Todoリストのテキストを変更
    const newTodos = [...todos];
    newTodos.find((todo) => todo.id === id).text = text;
    updateTodos(newTodos);
  };

  // Todo追加ボタンのクリックイベント
  const handleAddTodo = (text) => {
    // Todoリストに追加
    const newTodos = [...todos];
    newTodos.push({
      id: Date.now(),
      text: text,
      isCompleted: false
    });
    updateTodos(newTodos);
  };

  // Todo削除ボタンのクリックイベント
  // 完了済みのTodoを削除する
  const handlePurgeClick = () => {
    if (!window.confirm("完了済みの項目を削除します。よろしいですか?")) {
      return;
    }
    const newTodos = todos.filter((todo) => !todo.isCompleted);
    updateTodos(newTodos);
  };

  // APIKeyをlocalStorageにセットする
  const handleAPIKeySubmit = (key) => {
    setApiKey(key);
    localStorage.setItem("apiKey", key);
  };

  // Todoリストを表示
  const TodoList = todos.map((todo) => {
    return(
      <ListItem key={todo.id} todo={todo} onDeleteClick={handleTodoDeleteClick} onCheckboxChange={handleCheckboxChange} onEditClick={handleTodoEditClick} />
    )}
  );

  return (
    <div className="App">
      <h1>
        Todos
        <div className="button-group">
          {/* AIボタン */}
          <AIButton todos={todos} apiKey={apiKey} />
          {/* 一括削除ボタン */}
          <Button size="sm" outline id="purge" onClick={handlePurgeClick}>Purge</Button>
        </div>
      </h1>
      <ul id="todos">
        {TodoList}
      </ul>
      {/* 追加フォーム */}
      <AddForm onAddClick={handleAddTodo} />
      {/* API Key設定ボタン */}
      <SetAPIKey apiKey={apiKey} onSubmit={handleAPIKeySubmit} />
      {/* コピーライト */}
      <footer className="copyright">
        ©Nihon Unitec Co., Ltd. All rights reserved.
      </footer>
    </div>
  );
}

/*
  Todoリストのコンポーネント
  - Todoの各項目を表示するコンポーネント
  - Todoのテキスト、削除ボタン、編集ボタン、チェックボックスを表示
*/
function ListItem(props){

  // チェックボックスの状態変化検知イベント
  const CheckboxChange = (event) => {
    // 親コンポーネントの関数を呼び出す
    props.onCheckboxChange(props.todo.id, event.target.checked);
  }

  // 削除ボタンのクリックイベント
  const DeleteClick = () => {
    if (!window.confirm("本当に削除しますか?")) {
      return;
    }
    // 親コンポーネントの関数を呼び出す
    props.onDeleteClick(props.todo.id);
  }

  // 編集ボタンのクリックイベント
  const EditClick = () => {
    var result;
    do {
      result = prompt("入力してください", props.todo.text);
      // キャンセルボタンを押した場合
      if (result === null) {
        return;
      }
      // 空文字の場合
      if (result === "") {
        alert("入力してください");
      }
    } while (result === "");

    // 親コンポーネントの関数を呼び出す
    props.onEditClick(props.todo.id, result);
  }

  return(
    <li className="todo-item">
      <Label className="todo-label">
        {/* チェックボックス */}
        <Input type="checkbox" className="todo-check" onChange={CheckboxChange} checked={props.todo.isCompleted}/>
        {/* ToDoテキスト */}
        <span className="todo-text">{props.todo.text}</span>
      </Label>
      <div className="button-group">
        {/* 削除ボタン */}
        <Button size="sm" outline onClick={DeleteClick}>Del</Button>
        {/* 編集ボタン */}
        <Button size="sm" outline onClick={EditClick}>Edit</Button>
      </div>
    </li>
  )
}

/*
  Todo追加フォームのコンポーネント
*/
function AddForm(props){

  const [text, setText] = useState("");

  const inputRef = useRef(null);
  
  // フォームのsubmitイベント
  const handleSubmit = (event) => {
    event.preventDefault();
    if (text === "") {
      alert("入力してください");
      return;
    }
    // Todoリストに追加
    // 親コンポーネントの関数を呼び出す
    props.onAddClick(event.target.elements[0].value);
    setText("");
    inputRef.current.focus();
  }

  const handleChange = (event) => {
    setText(event.target.value);
  }

  return (
    <form onSubmit={handleSubmit}>
      {/* テキストボックス */}
      <input type="text" value={text} onChange={handleChange} ref={inputRef} />
      {/* 追加ボタン */}
      <Button size="sm" outline >Add</Button>
    </form>
  );
}
export default App;
